import { createContext, type ReactNode } from "react";
import type { CoverBackground } from "@/pages/raise-board/rb-ui";

/**
 * What the submission page puts on every step's ink band: the "Step N of 4"
 * line and an optional control beside it (Back). Steps render their own title
 * and description; the band frames them.
 */
export interface StepCoverValue {
  eyebrow?: ReactNode;
  aside?: ReactNode;
  /** The fund's chosen header ground, so the band matches its portal. */
  background?: CoverBackground | null;
}

export const StepCoverContext = createContext<StepCoverValue | null>(null);
